




































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class SectionedList extends Vue {
  @Prop(Array) readonly sections!: Array<any>
  @Prop(String) readonly sectionKey!: string
  @Prop(String) readonly sectionTitle!: string
  @Prop(String) readonly sectionItems!: string
  @Prop(String) readonly itemKey!: string
  @Prop(String) readonly itemTitle!: string
  @Prop(Boolean) readonly editable!: boolean
  @Prop(Boolean) readonly disabled!: boolean
  @Prop(Boolean) readonly icons!: boolean
}
